import { Box, Stack } from '@mui/material';
import PrimaryButton from '../buttons/primaryButton';
import ScoreDisplay from '../playerDisplay/scoreDisplay';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/authContext';

const GameCompleteCard = ({ event, game, actions, isPublic, bsaNumber, portal }) => {
  const navigate = useNavigate();

  const { currentUser } = useAuth();

  return (
    <Stack justifyContent={'space-between'} height="100%">
      <ScoreDisplay game={game} />

      {/* {(actions || currentUser.uid === game.scorer) && ( */}
      <Box display={'flex'} flexDirection={'row'} alignSelf={'center'} justifySelf={'flex-end'}>
        {portal ? (
          portal.detail ? null : (
            <PrimaryButton
              color="info"
              variant="contained"
              onClick={() => portal.openGame(game.id)}>
              View
            </PrimaryButton>
          )
        ) : currentUser ? (
          <PrimaryButton
            color="info"
            variant="contained"
            onClick={() => navigate(`/game/scoring/${game.id}`)}>
            View
          </PrimaryButton>
        ) : isPublic ? (
          <PrimaryButton
            color="info"
            variant="contained"
            onClick={() =>
              navigate(
                `/public/scoring-game/${game.id}${bsaNumber ? `?bsa=${encodeURIComponent(bsaNumber)}` : ''}`
              )
            }>
            View
          </PrimaryButton>
        ) : (
          <PrimaryButton
            color="info"
            variant="contained"
            onClick={() => navigate(`/embed/games/${game.id}`)}>
            View Score Card
          </PrimaryButton>
          ///embed/games/:sectionId/:gameId
        )}
      </Box>
      {/* )} */}
    </Stack>
  );
};

export default GameCompleteCard;
